import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { EventEmitter, inject, Injectable, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';

import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject, catchError, filter, map, Observable, of, Subject, Subscription, tap } from 'rxjs';
import { MdbModalService } from 'src/lib/mdb5-adapted/public-api';
//import { AuthenticationService } from './authentication.service';
import { AppUtilityService } from 'src/app/app-utility.service';
import { TokenService } from 'src/app/core/interceptors/token.service';
import { ApiloaderService } from 'src/app/shared/loaders/apiloader/apiloader.service';
import { environment } from 'src/environments/environment';

export type ConsultantProcessMode = 'desktop' | 'field';

@Injectable()
export class UserService implements OnDestroy {
  private static readonly consultantProcessModeStorageKey = 'consultantProcessMode';
  private oauthService = inject(OAuthService);
  private tokenService = inject(TokenService);
  @Output() onLogginChanged = new EventEmitter<boolean>();
  @Output() onLMSProfileLoaded = new EventEmitter<any | null>();
  @Output() KCEventChanged = new EventEmitter<OAuthEvent>();

  private UserEvent$ = new Subject<OAuthEvent>();
  private userbranch$ = new BehaviorSubject<any | null>(null);
  public LMSUserProfile$ = this.userbranch$.asObservable();

  private _isUserLoggedin = new BehaviorSubject<boolean>(false);
  public LMSUserLoggedIn$ = this._isUserLoggedin.asObservable();

  private _menusControl = new BehaviorSubject<any[]>([]);
  private _menuOriginal = new BehaviorSubject<any[]>([]);
  private fingerAuthentication = new BehaviorSubject<boolean>(false);

  //currentUser: User | null = this.auth.currentUser;
  private userSubscription: Subscription[] = [];

  private userBranch_apiURL = `${environment.apiUrl}/loan/api/user-branch`;
  private menu_apiURL = `${environment.apiUrl}/loan/menu`;
  accessToken: any;
  userDetails = new BehaviorSubject<any>({});
  private _currentIDClaims: Record<string, any>;

  private MenuOriginal$ = this._menuOriginal.asObservable();
  public MenusControl$ = this._menusControl;
  HttpParamsOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
    private global_utility: AppUtilityService,
    private apiloaderService: ApiloaderService,
    public route: Router,
    private modalService: MdbModalService
  ) {
    this.userbranch$.pipe(filter(usr => usr != null)).subscribe(user => this._currentProfile == user);
  }

  get isKCAuthenticated() {
    return this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken();
  }

  private useUserMenus = (menus: any[]) => {
    this._menusControl.next(menus);
  };


  get UserProfile(): Observable<any> {
    return this.userbranch$.asObservable();
  }

  private _currentProfile: any | null = null;
  public getLMSProfile(): any | null {
    return this._currentProfile ?? null;
  }

  private setProfile(profile: any) {
    //const hasChanged = this.lmsUserProfile !== profile;

    this._currentProfile = profile;
    this.userbranch$.next(profile);

    // Set logged in status based on whether profile exists
    const isLoggedIn = profile !== null && profile !== undefined;
    this._isUserLoggedin.next(isLoggedIn);

    if(this.onLogginChanged) {
      this.onLogginChanged.emit(isLoggedIn);
    }
    if(this.onLMSProfileLoaded) {
      this.onLMSProfileLoaded.emit(profile);
    }
  }

    // Inside your Angular Service or Component
    updateProfileGeoStatus() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const payload = {
            consultantId: this._currentProfile.id, // Replace with dynamic ID
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };

          return this.http.post(`${this.userBranch_apiURL}/check-status`, payload, this.HttpParamsOptions)
          .subscribe(status => console.log('Current Status:', status));
        });
      }
    }

  loadLMSUserProfile() {
    // Removed check for already logged in user to allow profile refresh/reload
    return new Promise<void>(async (resolveFn, rejectFn) => {

      // Check if we have valid OAuth tokens - this is the authoritative source
      if (!(this.oauthService.hasValidIdToken() || this.oauthService.hasValidAccessToken())) {
        console.warn('Cannot load LMS profile: No valid OAuth tokens - login required');
        // Don't log error - this is expected when session expires or browser is closed
        rejectFn(new Error('No valid OAuth tokens'));
        return;
      }

      let idClaims = this.oauthService.getIdentityClaims();
      if (!idClaims || !idClaims['sub']) {
        console.warn('No valid ID claims found, attempting to load user profile');
        try {
          await this.oauthService.loadUserProfile();
          idClaims = this.oauthService.getIdentityClaims();

          if (!idClaims || !idClaims['sub']) {
            console.error('Still no valid ID claims after loading user profile');
            rejectFn(new Error('Unable to retrieve user identity claims'));
            return;
          }
        } catch (error) {
          console.error('Failed to load user profile from OAuth provider:', error);
          rejectFn(new Error('Failed to load user profile'));
          return;
        }
      }

      this._currentIDClaims = idClaims;
      this.getLoggedInUserDetails().pipe(tap(usr=>{
        console.log("Loaded LMS user-----:", usr);
      })).subscribe({
        next: (lmsUser: any) => {
          if (lmsUser) {
            const isNewUser = (lmsUser.loginName && lmsUser.loginName !== this.global_utility.getGlobalData("user_LoginName")) || !this.global_utility.getGlobalData("user_LoginName");

            if(isNewUser) {
              // New user or first login - set all global data
              this.global_utility.setGlobalData('userDisplay', lmsUser.nameSurname);
              this.global_utility.setGlobalData('user_LoginName', lmsUser.loginName);
              this.global_utility.setGlobalData('branch_serial', lmsUser.delfinBranchSerial);
              this.global_utility.setGlobalData('branch_Name', lmsUser.branchName);
              this.global_utility.setGlobalData('user_jobtitle', lmsUser.jobTitle.jobTitle);
              this.global_utility.setGlobalData('user_Landing', lmsUser.jobTitle.component);
               this.global_utility.setGlobalData('userKey', lmsUser.id);
               console.log('Set global data for new user:', lmsUser);
            }

            // Always load menus and navigate (for both new and cached users)
            this.getUserMenu(this._currentIDClaims['sub'], lmsUser).then((valid) => {
              if (valid) {
                this.setFingerValid(false);
                if (!this.canUseConsultantProcessModeToggle) {
                  this.setConsultantProcessMode('desktop');
                }
                const component = lmsUser!.jobTitle?.component;
                if(!localStorage.getItem('LocalUser') || localStorage.getItem('LocalUser') != JSON.stringify(lmsUser)) {
                  localStorage.setItem('LocalUser',JSON.stringify(lmsUser));
                }

                this.global_utility.setGlobalData('user_Landing', component);

                // Clarified logic for determining the landing component
                const isComponentMissing = !component;
                const isBranchConsultant = component === 'branchconsultant';
                const isSystemOwner = lmsUser.jobTitle && lmsUser.jobTitle.jobTitle === 'System Owner';

                if (isComponentMissing || isBranchConsultant || isSystemOwner) {
                  this.global_utility.setGlobalData('user_Landing', '/agent');
                  lmsUser.jobTitle.component = '/agent';
                }

                const redirectUrl = localStorage.getItem('postLoginRedirectUrl');
                if (redirectUrl) {
                  localStorage.removeItem('postLoginRedirectUrl');
                  void this.route.navigateByUrl(redirectUrl);
                  resolveFn();
                  return;
                }

                this.navigateToLanding();
                resolveFn();
              } else {
                console.warn('User menu loading returned invalid result');
                this.global_utility.stopLoading();
                rejectFn(new Error('Menu loading failed'));
              }
            })
            .catch((reason) => {
              console.error('Menu loading error:', reason);
              this.global_utility.error('Failed to load user menus. Please try again or contact support.', 'Menu Load Error');
              this.setNoMenus(true);
              this.setFingerValid(false);
              this.global_utility.stopLoading();
              rejectFn(reason);
            });

            this.setProfile(lmsUser);
          } else {
            console.warn('No LMS user data received');
            this.global_utility.stopLoading();
            rejectFn(new Error('No user data'));
          }
        },
        error: (error) => {
         this.global_utility.stopLoading();
          this.global_utility.navigateToLanding();
          this.setProfile(null);
          if(error && error.statusText =='Unknown Error'){
            this.global_utility.handleError(error.statusText,undefined,false);
          }
          this.apiloaderService.setAPIStatus(false);
          console.error('Load LMS User Error: ', error ?? 'Unknown Error');
        }
      });
    });
  }

  private getLoggedInUserDetails() {
    const uuid = this._currentIDClaims['sub'];

    const lmsUser = localStorage.getItem('LocalUser') ? JSON.parse(localStorage.getItem('LocalUser') || '{}') : null;
    if(lmsUser && lmsUser.keyclockUuid === uuid) {
      const usr = JSON.parse(localStorage.getItem('LocalUser') || '{}');
      this.userDetails.next(usr);
      this.setProfile(usr);
      return of(usr);
    }

    return this.http.get<any>(`${this.userBranch_apiURL}/uuid/${uuid}`, this.HttpParamsOptions);
  }

  private getUserMenu(uuid: string, usrDetails: any) {
    return new Promise<boolean>((resolve, reject) => {
      if (!this.userDetails) {
        reject(new Error('Not a valid LMS user.'));
      }

      //Filtered Keycloak roles
      const rolefilter = this._currentIDClaims['realm_access']?.roles.filter((r: any) => {
        return ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_APPROVER'].includes(r) || [];
        //const rr = Array.from<string>(r.realm_access.roles);
        //return rr.some((r) => ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_APPROVER'].includes(r));
      });
      //console.log(rolefilter);

      // BUILD MENU
      this.getUserMenus(rolefilter.join(','), uuid, usrDetails.jobTitle).subscribe({
        next: (menus1) => {
          if (!this._menuOriginal.getValue()) {
            this._menuOriginal.next(menus1);
          }

          if (menus1 && menus1.length > 0) {
            this.useUserMenus(menus1);
          }
          resolve(true);
        },
        error: (err) => {
          console.error('User Menus loading error:', err);
        },
      });
    });
  }

  setNoMenus(hideMenus: boolean) {
    if (hideMenus) {
      this._menusControl.next([]);
      return;
    }

    if (this._menuOriginal.getValue()) {
      //const previousMenus = this.menuHold.value;
      this.useUserMenus(this._menuOriginal.getValue());
    }
  }

  private getUserMenus(roles: any, uuid: any, jobTitle: any) {
    const userRoles = { roles, uuid, jobTitle };
    return this.http.post<any>(`${this.menu_apiURL}/getMenusByUuid`, userRoles).pipe(tap(usr=>{
      console.log("loaded userMenus: ", usr);
      }),
      catchError((err, caught) => {
        if(err.status === 0){
          this.global_utility.handleError('Server is not reachable. Please check your internet connection or try again later.','Server not reachable',false);
          return caught;
        }

        this.global_utility.error(err, 'User not Loaded');
        return caught;
      })
    );
  }

  get isFingerAuth() {
    return this.fingerAuthentication.getValue();
  }

  get consultantProcessMode(): ConsultantProcessMode {
    const mode = sessionStorage.getItem(UserService.consultantProcessModeStorageKey) as ConsultantProcessMode | null;
    return mode === 'field' ? 'field' : 'desktop';
  }

  get isFieldAgentMode(): boolean {
    return this.consultantProcessMode === 'field';
  }

  get canUseConsultantProcessModeToggle(): boolean {
    const profile = this.getLMSProfile() || JSON.parse(localStorage.getItem('LocalUser') || '{}');
    const isBranchConsultant = profile?.jobTitle?.jobTitle === 'Branch Consultant' || this.userJobTitle === 'Branch Consultant';
    const isBranchManager = profile?.jobTitle?.jobTitle === 'Branch Manager' || this.userJobTitle === 'Branch Manager';
    const hasRelatedBranch = Boolean(profile?.relatedBranch);

    console.group('Checking consultant process mode toggle availability:');
    console.log('User Job Title:', profile?.jobTitle?.jobTitle);
    console.log('Has Related Branch:', hasRelatedBranch);
    console.log('Is Branch Consultant:', isBranchConsultant);
    console.log('Is Branch Manager:', isBranchManager);
    console.groupEnd();

    return hasRelatedBranch && (isBranchConsultant || isBranchManager);
  }

  setConsultantProcessMode(mode: ConsultantProcessMode): void {
    const selectedMode: ConsultantProcessMode = mode === 'field' ? 'field' : 'desktop';
    sessionStorage.setItem(UserService.consultantProcessModeStorageKey, selectedMode);
  }

  public CurrentUser_Menus = () => {
    return this._menusControl.getValue();
  };

  public setFingerValid(validBoolean: boolean) {
    // this.toastrService.info('FingerAuth changing: fingerValid is ' + { validBoolean }, '', { positionClass: 'toast-top-center' });
    this.fingerAuthentication.next(validBoolean);
  }

  public navigateToLanding() {
    this.global_utility.navigateToLanding();
    this.global_utility.stopLoading();
  }

  get userLoginName() {
    return this.global_utility.getGlobalData('user_LoginName');
  }

  get userDisplayName() {
   return this.global_utility.getGlobalData('userDisplay');
  }

  get userBranchName() {
   return this.global_utility.getGlobalData('branch_Name');
  }

  get userBranchSerial() {
    return this.global_utility.getGlobalData('branch_serial');
  }

  get userJobTitle() {
    return this.global_utility.getGlobalData('user_jobtitle');
  }

  logOutUser() {
    console.log('🚪 Logging out user...');

    // Close all open modals to prevent portal attachment errors
    const openModals = (this.modalService as any).opensModals;
    if (openModals && openModals.length > 0) {
      console.log(`Closing ${openModals.length} open modal(s)`);
      for (const modalRef of openModals) {
        try {
          modalRef.close();
        } catch (e) {
          console.warn('Error closing modal:', e);
        }
      }
    }

    // Mark logout in progress to prevent token redirect attempts
    this.tokenService.markLogoutInProgress();

    this.setFingerValid(false);
    this.setConsultantProcessMode('desktop');
    this.setNoMenus(true);
    if(localStorage.getItem('LocalUser')) {
      localStorage.removeItem('LocalUser');
    }
    // Clear the user profile to ensure fresh profile load on re-login
    this.setProfile(null);
    // Clear auth redirect flag and token state to allow fresh login for next user
    this.tokenService.clearAuthState();

    // Ensure any visible loader is closed before redirecting out of the SPA
    this.global_utility.stopLoading();

    // Perform full IdP logout to terminate SSO session and return to app root
    this.oauthService.logOut();

    return;
    // this.oauthService.loadUserProfile().then(()=>{
    //   this.route.navigateByUrl('/').catch((reas) => {
    //   console.error('After logout Navigate: ',reas);
    // });
    // }).catch((err) => {
    //   console.error('LMS User tap ERROR >> ', err);
    // });
  }

  // getPublicContent(): Observable<any> {
  //   return this.http.get(this.userBranch_apiURL + 'all', { responseType: 'text' }).pipe(
  //     catchError((err,caught) => {
  //       this.global_utility.error(err, 'User not LOaded');
  //       return caught;
  //     }
  //     ));
  // }

  getUserAreaBranches(area: string): Observable<any> {
    return this.http.get(`${this.userBranch_apiURL}/userbranchareas/${area}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err, obs) => {
        obs.pipe(
          tap((val) => {
            console.error('LMS User tap ERROR >> ', val);
          })
        );
        console.error('LMS User ERROR >> ', err);
        this.global_utility.error('LMSUser: ' + err, 'User Verification Error');
        if (err instanceof HttpErrorResponse) {
          if (err.error && err.error.type == 'error' && err.statusText === 'Unknown Error') {
            //reject('SERVER OFFLINE');
          }
        }
        return of(err);
      })
    );
  }

  ngOnDestroy() {
    this.userSubscription.forEach((x) => {
      x.unsubscribe();
    });

    this._menusControl.unsubscribe();
  }
}
